import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage"; // ✅ 1. Import getStorage
// Your project's Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyD1Z6zLPtvgs9oPRTSfrP3-SwCQqRYWWrg",
  authDomain: "drivio-dashboard-40e1f.firebaseapp.com",
  projectId: "drivio-dashboard-40e1f",
  storageBucket: "drivio-dashboard-40e1f.appspot.com", // ❗ fixed typo here (was `.app`)
  messagingSenderId: "552209210254",
  appId: "1:552209210254:web:0ae6a6b970dcf9c93522df"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services with proper region
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "us-central1"); // ✅ specify region explicitly
export const storage = getStorage(app);
